var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "conteiner" },
      [
        _c(
          "el-tabs",
          {
            staticClass: "content",
            attrs: { value: _vm.menu },
            on: { "tab-click": _vm.mudarTab }
          },
          [
            _vm._l(_vm.tabs, function(tab) {
              return [
                _c("el-tab-pane", { attrs: { name: tab.name } }, [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(tab.label) + "  ")
                  ])
                ])
              ]
            })
          ],
          2
        ),
        _c("app-opcoes-header-analise", {
          staticClass: "right",
          attrs: {
            idProcesso: _vm.processo.id,
            protocolo: _vm.processo.numeroProtocolo,
            statusProcesso: _vm.processo.status,
            numeroProcesso: _vm.processo.numeroProcesso,
            btnRetificacao: true,
            btnPendencia: true,
            tipoProcesso: _vm.processo.tipo.codigo
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "container-tab" },
      [
        _vm.loaded
          ? _c("router-view", {
              attrs: {
                oficios: [_vm.oficio],
                processo: _vm.processo,
                despacho: _vm.despacho,
                isEdicao: _vm.isEdicao
              },
              on: { atualizarOficio: _vm.atualizarOficio }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6951691c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6951691c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/oficio/Oficio.vue
// module id = null
// module chunks = 